<template>
  <v-card
    class="py-2 bb-1"
    elevation="0"
  >
    <v-card-text>
      <v-row>
        <v-col
          class="d-flex justify-start align-start"
          cols="2"
        >
          <v-btn
            :to="{ name: 'Dashboard' }"
            class="hover-td-none-deep"
            prepend-icon="arrow_back"
            role="link"
            variant="text"
          >
            {{ $bct('Back') }}
          </v-btn>
        </v-col>
        <v-col
          class="d-flex justify-center align-center"
          cols="8"
        >
          <h1>{{ title }}</h1>
        </v-col>
        <v-col
          class="d-flex justify-end"
          cols="2"
        />
      </v-row>
      <v-row v-if="titleSubtext">
        <v-col class="d-flex justify-center c-dark-gray">
          {{ titleSubtext }}
        </v-col>
      </v-row>
      <v-row v-if="subtitle">
        <v-col class="d-flex justify-center">
          <h2>{{ subtitle }}</h2>
        </v-col>
      </v-row>
      <v-row v-if="subtitleSubtext">
        <v-col class="d-flex justify-center c-dark-gray">
          {{ $bct(subtitleSubtext) }}
        </v-col>
      </v-row>
      <v-row>
        <v-col class="d-flex justify-center align-center">
          <v-icon
            class="me-3"
            color="green"
            icon="check_circle"
          />
          <h3>
            <LongDateTime
              :date="submittedAt"
              prefix="Application submitted"
            />
          </h3>
        </v-col>
      </v-row>
    </v-card-text>
  </v-card>
</template>

<script setup>
import LongDateTime from '@/shared/components/LongDateTime.vue';

const $bct = inject('translator');

defineProps({
  title: {
    type: String,
    required: true,
  },
  titleSubtext: {
    type: String,
    default: null,
  },
  subtitle: {
    type: String,
    default: null,
  },
  subtitleSubtext: {
    type: String,
    default: null,
  },
  submittedAt: {
    type: String,
    required: true,
  },
});
</script>
